import React from 'react';
import Project from './Project';
import './Day.css';

const Day = ({ id, date, projects, resources, onAddResource }) => {
  // Note: Component reused for project rows
  // 'id' is now projectId
  // 'date' is now project title
  // 'projects' is now the days array
  
  return (
    <div className="day-row">
      {/* First cell shows project title */}
      <div className="day-date-cell">{date}</div>
      
      {/* Map through days (stored in 'projects' prop) */}
      {projects.map((day) => {
        // Filter resources by current project (id) and current day (day.id)
        const dayResources = resources.filter(r => r.projectId === id && r.dayId === day.id);
        
        return (
          <Project
            key={day.id}
            id={id}
            dayId={day.id}
            resources={dayResources}
            onAddResource={onAddResource}
            showHeader={false}
          />
        );
      })}
    </div>
  );
};

export default Day;
